import { Box } from "@mui/material";
import {
	SingleInputDateRangeField,
	StaticDateRangePicker,
} from "@mui/x-date-pickers-pro";
import React, {
	useCallback,
	useEffect,
	useRef,
	useState,
	useContext,
} from "react";
import { useTranslation } from "react-i18next";
import { shortcuts } from "utils/Times";
import { Context } from "../Context";

const Step3 = () => {
	const { t } = useTranslation();

	const { selectedDates, setSelectedDates } = useContext(Context);

	const [boxWidth, setBoxWidth] = useState(0);
	const [calendars, setCalendars] = useState(0);

	const boxRef = useRef(null);

	const numCalendars = useCallback(() => {
		const widthCalendars = boxWidth - 172;

		const nCalendars = Math.floor(widthCalendars / 312);

		console.log(
			"widthCalendars: ",
			widthCalendars,
			"nCalendars: ",
			nCalendars,
			"calendars",
			parseInt(nCalendars)
		);

		if (parseInt(nCalendars) > 1) {
			setCalendars(parseInt(nCalendars));
		} else {
			setCalendars(1);
		}
	}, [boxWidth]);

	useEffect(() => {
		const handleResize = () => {
			if (boxRef.current) {
				const width = boxRef.current.getBoundingClientRect().width;
				setBoxWidth(width);
				console.log("Box width:", width);
				numCalendars();
			}
		};

		const observer = new window.ResizeObserver(handleResize);

		if (boxRef.current) {
			observer.observe(boxRef.current);
			// Inicializa el ancho al montar
			handleResize();
		}

		return () => {
			observer.disconnect();
		};
	}, [numCalendars]);

	return (
		<Box
			ref={boxRef}
			sx={{
				mt: "3.5vw",
				display: "flex",
				alignContent: "center",
				justifyContent: "center",
				width: "100%",
			}}
		>
			{/* Puedes usar boxWidth aquí si lo necesitas */}
			<StaticDateRangePicker
				slots={{ field: SingleInputDateRangeField }}
				slotProps={{
					shortcuts:
						boxWidth > 485
							? {
									items: shortcuts(t),
							  }
							: undefined,
					actionBar: { actions: [] },
				}}
				calendars={calendars}
				value={selectedDates}
				onChange={(nv) => setSelectedDates(nv)}
			/>
		</Box>
	);
};

export { Step3 };
